import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { ORG_DATABASE_ROUTE, ORG_ROUTE, PROJECT_ROUTE } from '@/shared/constants'
import { EVENT_KEYS } from '@/shared/custom-event'

/**
 * Custom hook to determine if requests should be delayed based on current route
 * Delays requests when user is on /db or project (/p) routes.
 *
 * If shouldDelay, it will wait for the dbClient to be opened before making the request.
 *
 */
export function useDeferRequests() {
  const [tableDataLoad, setTableDataLoad] = useState(false)

  const location = useLocation()

  const shouldFetch = useMemo(() => {
    const pathname = location.pathname
    const pathSegments = pathname.split('/')

    const isDbTableRoute = pathname.startsWith(ORG_ROUTE) && pathSegments.includes(ORG_DATABASE_ROUTE) && !pathname.endsWith(ORG_DATABASE_ROUTE)
    const isProjectRoute = pathname.startsWith(PROJECT_ROUTE)
    const isDeferredRoutes = isDbTableRoute || isProjectRoute

    const noFetch = isDeferredRoutes && !tableDataLoad

    return !noFetch
    //
  }, [location.pathname, tableDataLoad])

  useEffect(() => {
    const handler = () => {
      setTableDataLoad(true)
    }
    window.addEventListener(EVENT_KEYS.DB_OPENED, handler)
    return () => window.removeEventListener(EVENT_KEYS.DB_OPENED, handler)
  }, [])

  return {
    shouldFetch,
  }
}
